import axios from "axios";
import { IBookingsApiFilter } from "../types";

export interface IGetPendingListCountParams {
    filters?: IBookingsApiFilter,
}

export const getPendingListCount = async (params: IGetPendingListCountParams): Promise<number> => {
    const response = await axios.post('/booking/search/pending-list/counter', params);
    return response.data;
};